/**
 * @generated SignedSource<<86a7ef9967a835af5f26f5a050a9d58b>>
 * @relayHash 4e2dbb7ac42e698d4b8d14f8de008aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b06dfc4daaafb36a569456905e0b413b020394c237510308dfc32078fbf0646

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentViewStandardFlowQuery } from './VirtualAgentViewStandardFlowQuery.graphql';

import checkForAiEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentViewStandardFlowQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2b06dfc4daaafb36a569456905e0b413b020394c237510308dfc32078fbf0646",
    "metadata": {},
    "name": "VirtualAgentViewStandardFlowQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
